// SWIPER
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';

export function init() {

    if (!document.querySelector('.swiper')) {
        return;
    }

    const banner = new Swiper(".banner-slider", {
        modules: [Autoplay, Navigation, Pagination],
        loop: true,
        grabCursor: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".slider-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".slider-button.next",
            prevEl: ".slider-button.prev",
        },
    });
}
